define([], function () {
    return {
        UNKNOWN: 'unknown',
        LONG_POLLING: 'long-polling',
        WEBSOCKET: 'websocket'
    };
});
